'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherChevronDown, FeatherChevronRight } from '@subframe/core';
import { useState } from 'react';
import type { CategoriaBreakdown, EventoConsumo } from '../types';
import { formatarDataHora, formatarMoedaBR } from '../utils/apuracaoFormatters';
import { categoriaEventoIcon, categoriaEventoLabel } from '../utils/apuracaoStatusConfig';
interface ApuracaoCategoriaBreakdownProps {
  breakdown: CategoriaBreakdown[];
  eventos: EventoConsumo[];
  onAbrirEvento: (evento: EventoConsumo) => void;
}
export function ApuracaoCategoriaBreakdown(t0) {
  const $ = _c(15);
  const {
    breakdown,
    eventos,
    onAbrirEvento
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new Set();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [expandidas, setExpandidas] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = categoria => {
      setExpandidas(prev => {
        const next = new Set(prev);
        if (next.has(categoria)) {
          next.delete(categoria);
        } else {
          next.add(categoria);
        }
        return next;
      });
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const toggle = t2;
  if (breakdown.length === 0) {
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="bg-default-background flex flex-col items-center justify-center gap-2 rounded-[16px] border border-dashed border-neutral-200 px-6 py-12 text-center"><span className="text-body-bold font-body-bold text-default-font">Nenhum evento apurado ainda</span><span className="text-body font-body text-subtext-color">Quando o time interno registrar eventos de consumo, eles aparecerão aqui agrupados por tipo.</span></div>;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    return t3;
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="grid grid-cols-[2fr_1fr_1fr_1fr_44px] gap-4 border-b border-solid border-neutral-100 bg-neutral-50/60 px-5 py-3"><span className="text-caption-bold font-caption-bold text-subtext-color uppercase">Categoria</span><span className="text-caption-bold font-caption-bold text-subtext-color uppercase">Quantidade</span><span className="text-caption-bold font-caption-bold text-subtext-color uppercase">Valor unitário</span><span className="text-caption-bold font-caption-bold text-subtext-color text-right uppercase">Subtotal</span><span className="sr-only">Expandir</span></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== breakdown || $[5] !== eventos || $[6] !== expandidas || $[7] !== onAbrirEvento) {
    let t5;
    if ($[9] !== eventos || $[10] !== expandidas || $[11] !== onAbrirEvento) {
      t5 = item => {
        const Icon = categoriaEventoIcon[item.categoria];
        const isOpen = expandidas.has(item.categoria);
        const eventosCategoria = eventos.filter(e => item.eventosIds.includes(e.id));
        return <li key={item.categoria}><button type="button" onClick={() => toggle(item.categoria)} className="grid w-full grid-cols-[2fr_1fr_1fr_1fr_44px] items-center gap-4 px-5 py-4 text-left transition-colors hover:bg-neutral-50"><div className="flex items-center gap-3"><span className="bg-brand-50 text-brand-600 flex h-8 w-8 items-center justify-center rounded-lg"><Icon className="h-4 w-4" /></span><span className="text-body-bold font-body-bold text-default-font">{categoriaEventoLabel[item.categoria]}</span></div><span className="text-body font-body text-default-font">{item.quantidade}</span><span className="text-body font-body text-neutral-700">{item.valorUnitarioMedio != null ? formatarMoedaBR(item.valorUnitarioMedio) : "\u2014"}</span><div className="flex flex-col items-end"><span className="text-body-bold font-body-bold text-default-font">{formatarMoedaBR(item.subtotal)}</span>{item.descontoTotal > 0 && <span className="text-success-700 text-caption font-caption">− {formatarMoedaBR(item.descontoTotal)} desconto</span>}</div><span className="flex h-8 w-8 items-center justify-center text-neutral-400">{isOpen ? <FeatherChevronDown className="h-4 w-4" /> : <FeatherChevronRight className="h-4 w-4" />}</span></button>{isOpen && <div className="bg-neutral-50/40 px-5 pb-4"><ul className="flex flex-col gap-2">{eventosCategoria.map(evento => <li key={evento.id} className="bg-default-background flex items-center justify-between rounded-[8px] border border-solid border-neutral-200 px-4 py-3"><div className="flex min-w-0 flex-1 flex-col gap-0.5"><span className="text-body font-body text-default-font truncate">{evento.origemLabel}</span><span className="text-caption font-caption text-subtext-color">{formatarDataHora(evento.timestamp)}{" \xB7 "}qtd {evento.quantidade}</span></div><div className="flex items-center gap-3"><span className="text-body-bold font-body-bold text-default-font">{formatarMoedaBR(evento.valorCobravel)}</span><button type="button" onClick={() => onAbrirEvento(evento)} className="text-brand-600 hover:text-brand-700 text-caption-bold font-caption-bold">Ver detalhe</button></div></li>)}</ul></div>}</li>;
      };
      $[9] = eventos;
      $[10] = expandidas;
      $[11] = onAbrirEvento;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    t4 = breakdown.map(t5);
    $[4] = breakdown;
    $[5] = eventos;
    $[6] = expandidas;
    $[7] = onAbrirEvento;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[13] !== t4) {
    t5 = <div className="bg-default-background flex flex-col overflow-hidden rounded-[16px] border border-solid border-neutral-200">{t3}<ul className="divide-y divide-neutral-100">{t4}</ul></div>;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}